import { connect } from 'react-redux'
import { SMSCard as SMSComponent } from 'transfix-ui/components/SMSCard'
import { ISMSProps } from 'transfix-ui/components/SMSCard/components/SMS'
import { fetchSMS, sendSMS } from 'utils/actions/sms'
import { openDialog } from 'utils/actions/user'

interface IStateProps {
  childUsers: {
    users: any[]
  }
  sms: {
    list?: ISMSProps[]
    fetching?: boolean
    error?: boolean
    sending?: boolean
    sendError?: string
  }
  userProfile: {
    userProfileDetails: any
  }
}

export const SMS = connect(
  ({
    childUsers: { users },
    sms: { error, fetching, list, sendError, sending },
    userProfile: { userProfileDetails },
  }: IStateProps) => ({
    list,
    fetching,
    error,
    sending,
    sendError,
    user: userProfileDetails,
    to: users[0],
  }),
  { fetchSMS, sendSMS, editUserAction: openDialog }
)(SMSComponent)
